import { ChartData } from "chart.js";

import { Translation } from "@/data/lang";

import { InsiderHolding } from "../services/insider-holding";

export const extractInsiderHoldingChartData = ({
  t,
  data,
}: {
  t: Translation;
  data: InsiderHolding["historicalHoldings"];
}): ChartData<"bar" | "line"> => ({
  labels: data.map((d) => d.date),
  datasets: [
    {
      type: "line",
      label: t.analysis.chip.insiderHolding.closePrice,
      data: data.map((d) => d.closePrice ?? null),
      borderColor: "#0569A2",
      backgroundColor: "#0569A2",
      yAxisID: "y1",
      pointRadius: 0,
      spanGaps: true,
    },
    {
      type: "line",
      label: t.analysis.chip.insiderHolding.holdingRatio,
      data: data.map((d) => d.holdingRatio ?? null),
      borderColor: "#37BEF8",
      backgroundColor: "#EAF8FF",
      yAxisID: "y",
      pointRadius: 0,
      fill: "origin",
      spanGaps: true,
    },
  ],
});
